import { render, staticRenderFns } from "./ActivityDraggableTextButtonsForHotspots.vue?vue&type=template&id=0daa06b0&scoped=true"
import script from "./ActivityDraggableTextButtonsForHotspots.vue?vue&type=script&lang=ts"
export * from "./ActivityDraggableTextButtonsForHotspots.vue?vue&type=script&lang=ts"
import style0 from "./ActivityDraggableTextButtonsForHotspots.vue?vue&type=style&index=0&id=0daa06b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daa06b0",
  null
  
)

/* custom blocks */
import block0 from "./ActivityDraggableTextButtonsForHotspots.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports